import { module } from 'modujs';
import gsap from "gsap";

export default class extends module {
    constructor(m) {
        super(m);

        this.backgroundsWrap = this.el.querySelector('.realisation_hero_carousel');
        this.items = [...this.el.querySelectorAll('.realisation_hero_carousel_item')];
        this.nextButton = this.el.querySelector('.realisation_hero_carousel_next');
        this.countValue = this.el.querySelector('.carousel_count_value');

        this.currentIndex = 0;
        this.maxIndex = this.items.length - 1;
        this.currentZIndex = 1;
        this.isRunning = false;

        this.progressAnim = gsap.timeline({ delay: 4, repeatDelay: 4, repeat: -1});
        this.progressAnim.call(() => { this.playProgress(); });
        
        this.events = {
            click: {
                nextItem: 'nextItem'
            }
        }
    }

    playProgress() {
        let newIndex = this.currentIndex == this.maxIndex ? 0 : this.currentIndex + 1;
        this.showItem(newIndex);
    }

    showItem(index) {
        // If current is already active
        if (this.currentIndex == index) {
            return;
        }

        this.isRunning = true;

        let oldItem = this.items[this.currentIndex];

        if (oldItem) {
            oldItem.classList.remove('-active');
            gsap.to(
                oldItem.querySelector('.realisation_hero_carousel_item_blur'),
                { opacity: 1, duration: 0.3, ease: 'none' }
            );
            gsap.set(oldItem, {
                clipPath: 'polygon(0 0, 0 0, 0 100%, 0 100%)',
                delay: 1.6,
            });
            gsap.set(oldItem.querySelector('.c-media'), {
                scale: 1.2,
                delay: 1.6,
            });
            gsap.set(oldItem.querySelector('.realisation_hero_carousel_item_blur'), {
                opacity: 0,
                delay: 1.6,
            });
            this.pauseMedia(oldItem);
        }

        this.currentIndex = index;
        this.currentZIndex = this.currentZIndex + 1;

        let newItem = this.items[this.currentIndex];
        
        newItem.style.zIndex = this.currentZIndex;
        newItem.classList.add('-active');
        let tlNewItem = gsap.timeline();
        tlNewItem.fromTo(newItem, {
            clipPath: 'polygon(0 0, 0 0, 0 100%, 0 100%)',
        }, {
            clipPath: 'polygon(0 0,100% 0,100% 100%,0 100%)',
            duration: 1.2,
            ease: 'power3.inOut',
            onComplete: () => {
                this.isRunning = false;
            }
        }, 0.2);
        tlNewItem.fromTo(newItem.querySelector('.c-media'), {
            scale: 1.2,
        }, {
            scale: 1,
            duration: 1.2,
            ease: 'power3.inOut'
        }, 0.2);
        tlNewItem.fromTo(newItem.querySelector('.realisation_hero_carousel_item_mask'), {
            x: '-100%'
        }, {
            x: 0,
            duration: 1,
            ease: 'power3.out',
        }, 0.9);

        this.countValue.textContent = this.currentIndex + 1 <= 10 ? '0' + (this.currentIndex + 1) : this.currentIndex + 1;

        this.playMedia(newItem);
    }

    playMedia(mediaWrap) {
        if (mediaWrap.querySelector('video')) {
            mediaWrap.querySelector('video').play();
        }
    }

    pauseMedia(mediaWrap) {
        if (mediaWrap.querySelector('video')) {
            mediaWrap.querySelector('video').pause();
        }
    }

    nextItem(e) {
        if (this.isRunning) {
            return;
        }

        this.progressAnim.pause();
        let newIndex = this.currentIndex == this.maxIndex ? 0 : this.currentIndex + 1;
        this.showItem(newIndex);
    }

    toggle(e){
        if (e.way == 'leave') {
            if (this.progressAnim) {
                this.progressAnim.pause();
                this.pauseMedia(this.items[this.currentIndex]);
            }
        }
    }

}
